<template>
  <gw-entity-chooser
    class="a7-estado-entity-chooser"
    :search="search"
    :find-entity-by-id="findEntityByID" representation-field="nome"
    bindByID v-model="computedValue" :selection-support="a7EstadoListing" :disabled="disabled">
    <template slot="item" slot-scope="scope">
      <strong>{{$t('Estado.ui.chooser.nome')}}</strong><span>{{scope.entity.nome}}</span>
    </template>
  </gw-entity-chooser>
</template>

<script>
import { GwEntityChooser } from 'guaxinim-web'
import EstadoRestResource from './EstadoRestResource'
import A7EstadoListing from './A7EstadoListing'

export default {
  name: 'a7-estado-entity-chooser',
  components: {
    GwEntityChooser
  },
  props : {
    value : {
      type: Object | Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      a7EstadoListing: A7EstadoListing
    }
  },
  computed:{
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    }
  },
  methods: {
    search(pattern) {
      if (!pattern) return null
      return EstadoRestResource.findEstadoFinderDTO(null, pattern, 10)
    },
    findEntityByID(id) {
      return EstadoRestResource.findEntityByID(id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .a7-estado-entity-chooser {
    width: 100%;
  }
</style>
